import React, { useState } from 'react'
import '../styles/FullScreenImage.css'
import { FaExpand } from 'react-icons/fa6'

const FullScreenImage : React.FC<{ src : string; alt : string }> = ({ src, alt }) => {
  const [isFullScreen, setIsFullScreen] = useState(false)
  
  const handleFullScreen = () => {
    setIsFullScreen(true)
  }
  
  const handleExitFullScreen = () => {
    setIsFullScreen(false)
  }
  
  return (
    <div className="image-container">
      <img src={ src } alt={ alt } className="main-image img-fluid"/>
      <div className="icon-container" onClick={ handleFullScreen }>
        <FaExpand/>
      </div>
      { isFullScreen && (
        <div className="full-screen-overlay" onClick={ handleExitFullScreen }>
          <img src={ src } alt={ alt } className="full-screen-image img-fluid"/>
        </div>
      ) }
    </div>
  )
}

export default FullScreenImage
